import axios from '../../../commons/gdprcontrol-axios'

const scheduledEventSkeleton = {
  id: null,
  minute: null,
  hour: null,
  day_of_week: null,
  day_of_month: null,
  month_of_year: null,
  task: null,
  organization: null,
  user: null,
  user_group: null,
  subject: '',
  description: '',
  category: null,
  data_source: ''
}

const formDataSkeleton = {
  time: { HH: '06', mm: '00' },
  recurrenceType: 'daily',
  dailyRecurrence: 'daily',
  weeklyRecurrence: [],
  monthlyRecurrenceDay: 1,
  yearlyRecurrenceDay: 1,
  yearlyRecurrenceMonths: [],
  days: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31],
  data_source: {
    value: 'actual_date',
    text: ''
  }
}

const state = {
  scheduledEvent: Object.assign({}, scheduledEventSkeleton),
  simplifiedScheduledEvent: Object.assign({}, scheduledEventSkeleton),

  formData: Object.assign({}, formDataSkeleton)
}

const getters = {
  getScheduledEvent: state => state.scheduledEvent,
  getSimplifiedScheduledEvent: state => state.simplifiedScheduledEvent,

  getformData: state => state.formData
}

const actions = {
  fetchScheduledEvent: async ({ commit }, scheduledEventId) => {
    return axios.get(`/api/events-schedule/${scheduledEventId}/`)
      .then(response => {
        commit('setScheduledEvent', Object.assign({}, response.data))
        commit('setSimplifiedScheduledEvent', Object.assign({}, response.data))
        actions.fetchScheduleForm()
      })
      .catch(error => {
        alert('Hiba az ütemezett esemény letöltése közben')
        throw error
      })
  },

  saveNewScheduledEvent: async ({ commit, state }, event) => {
    const schedule = methods.getScheduleFromForm()
    return axios.post('/api/events-schedule/', Object.assign({}, event, schedule))
  },

  updateScheduledEvent: async ({ commit, state }) => {
    const schedule = methods.getScheduleFromForm()
    return axios.put(`/api/events-schedule/${state.scheduledEvent.id}/`, Object.assign({}, state.simplifiedScheduledEvent, schedule))
  },

  deleteScheduledEvent: async ({ commit, state }) => {
    return axios.delete(`/api/events-schedule/${state.scheduledEvent.id}/`)
  },

  fetchScheduleForm () {
    state.formData.time.mm = state.scheduledEvent.minute
    state.formData.time.HH = state.scheduledEvent.hour
    state.formData.data_source.value = state.scheduledEvent.data_source
    if (state.scheduledEvent.day_of_month === '*' && state.scheduledEvent.month_of_year === '*') {
      state.formData.recurrenceType = 'daily'
      if (state.scheduledEvent.day_of_week === '*') {
        state.formData.dailyRecurrence = 'daily'
      } else if (state.scheduledEvent.day_of_week === '1-5') {
        state.formData.dailyRecurrence = 'weekdays'
      } else if (state.scheduledEvent.day_of_week === '6,0') {
        state.formData.dailyRecurrence = 'weekends'
      } else {
        state.formData.recurrenceType = 'weekly'
        state.formData.weeklyRecurrence = state.scheduledEvent.day_of_week.split(',').map(Number)
      }
    } else if (state.scheduledEvent.day_of_month !== '*' && state.scheduledEvent.month_of_year === '*') {
      state.formData.recurrenceType = 'monthly'
      state.formData.monthlyRecurrenceDay = parseInt(state.scheduledEvent.day_of_month)
    } else if (state.scheduledEvent.day_of_month !== '*' && state.scheduledEvent.month_of_year !== '*') {
      state.formData.recurrenceType = 'yearly'
      state.formData.yearlyRecurrenceDay = parseInt(state.scheduledEvent.day_of_month)
      state.formData.yearlyRecurrenceMonths = state.scheduledEvent.month_of_year.split(',').map(Number)
    }
  }
}

const mutations = {
  setScheduledEvent (state, scheduledEvent) {
    state.scheduledEvent = scheduledEvent
  },

  setSimplifiedScheduledEvent (state, scheduledEvent) {
    if (scheduledEvent.user) {
      scheduledEvent.user = scheduledEvent.user.id
    } else {
      scheduledEvent.user_group = scheduledEvent.user_group.id
    }
    scheduledEvent.category = scheduledEvent.category.id
    state.simplifiedScheduledEvent = scheduledEvent
  },

  setAttribute (state, { name, value }) {
    state.simplifiedScheduledEvent[name] = value
  },

  resetScheduledEvent (state) {
    state.simplifiedScheduledEvent = Object.assign({}, scheduledEventSkeleton)
  },

  setFormDataAttribute (state, { name, value }) {
    state.formData[name] = value
  },

  resetFormData (state) {
    state.formData = Object.assign({}, formDataSkeleton)
    state.formData.time = Object.assign({}, formDataSkeleton.time)
  }
}

const methods = {
  getScheduleFromForm () {
    var schedule = {
      minute: state.formData.time.mm,
      hour: state.formData.time.HH,
      day_of_week: '*',
      day_of_month: '*',
      month_of_year: '*',
      data_source: state.formData.data_source.value
    }

    if (state.formData.recurrenceType === 'daily') {
      if (state.formData.dailyRecurrence === 'weekdays') {
        schedule.day_of_week = '1-5'
      } else if (state.formData.dailyRecurrence === 'weekends') {
        schedule.day_of_week = '6,0'
      }
    } else if (state.formData.recurrenceType === 'weekly') {
      state.formData.weeklyRecurrence.sort((a, b) => a - b)
      schedule.day_of_week = state.formData.weeklyRecurrence.join()
    } else if (state.formData.recurrenceType === 'monthly') {
      schedule.day_of_month = state.formData.monthlyRecurrenceDay
    } else if (state.formData.recurrenceType === 'yearly') {
      schedule.day_of_month = state.formData.yearlyRecurrenceDay
      state.formData.yearlyRecurrenceMonths.sort((a, b) => a - b)
      schedule.month_of_year = state.formData.yearlyRecurrenceMonths.join()
    }
    return schedule
  }
}

export default { state, getters, mutations, actions, methods }



// WEBPACK FOOTER //
// ./src/store/modules/scheduledEvents/details.js